export default {
	All: '',
	Accounting: 'J',
	AccountsPayable: 'AP',
	CustomerPhoneNumbers: 'H',
	Customers: 'C',
	Deals: 'D',
	Desks: 'S',
	JournalDetails: 'JR',
	PartsInvoices: 'I',
	Prospects: 'P',
	PurchaseOrders: 'PO',
	Receipts: 'RC',
	RepairOrders: 'R',
	Appointments: 'A',
	Vehicles: 'V',
	VehicleSales: 'VS',
	Vendors: 'N'
};
